import React from 'react';
import PropTypes from 'prop-types';
import Phone from '@mui/icons-material/Phone';
import { FormattedMessage } from 'react-intl';

const PhoneCallLabel = ({ call }) => {
  if (call.status === 'pending') {
    return <FormattedMessage defaultMessage="Phone call" />;
  }

  if (call.status === 'unknown') {
    return <FormattedMessage defaultMessage="Unknown phone caller" />;
  }

  return (
    <FormattedMessage
      defaultMessage="Phone call •••• {last4}"
      values={{ last4: call.from_number_last4 }}
    />
  );
};

const callShape = PropTypes.shape({
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  status: PropTypes.oneOf(['pending', 'resolved', 'unknown']),
  from_number_last4: PropTypes.string,
  video_session_connection_id: PropTypes.string.isRequired,
});

PhoneCallLabel.propTypes = { call: callShape.isRequired };

const PhoneCallParticipants = ({ voiceCalls }) => {
  if (voiceCalls.length === 0) return null;

  return (
    <div className="phone-call-participants">
      <p className="phone-call-participants__title">
        <FormattedMessage
          defaultMessage="{count, plural, one {# phone call connected} other {# phone calls connected}}"
          values={{ count: voiceCalls.length }}
        />
      </p>
      <ul className="phone-call-participants__list">
        {voiceCalls.map(call => (
          <li
            key={call.video_session_connection_id}
            className="phone-call-participants__item"
          >
            <span className="phone-call-participants__icon">
              <Phone fontSize="small" />
            </span>
            <span className="phone-call-participants__number">
              <PhoneCallLabel call={call} />
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

PhoneCallParticipants.propTypes = {
  voiceCalls: PropTypes.arrayOf(callShape).isRequired,
};

export default PhoneCallParticipants;
